import styled from "styled-components";

export const BolsaManualContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-bottom: 100px;
  
  h2 {
    margin: 0 0 0 0 !important;
  }
  
  .beauty-scrollbar{
    margin-top: 64px;
  }
  
  @media (max-width: 768px) {
    padding-bottom: 120px;
  }
`;
